const CONFIG_SELECTOR = 'script[data-feature-loader-config]';

const configElement = document.querySelector(CONFIG_SELECTOR);

if (configElement instanceof HTMLScriptElement) {
  /** @type {Array<{ selector: string, src: string, loading?: boolean }>} */
  let features = [];

  try {
    features = JSON.parse(configElement.textContent || '[]');
  } catch (error) {
    console.warn('Optional storefront features could not be configured.', error);
  }

  const loadFeature = (feature) => {
    if (feature.loading) return;
    feature.loading = true;

    import(feature.src).catch((error) => {
      feature.loading = false;
      console.warn(`Optional storefront feature failed to load: ${feature.selector}`, error);
    });
  };

  const findFeatures = (root) => {
    features.forEach((feature) => {
      if (feature.loading) return;

      const matchesRoot = root instanceof Element && root.matches(feature.selector);
      const containsMatch = 'querySelector' in root && root.querySelector(feature.selector) !== null;

      if (matchesRoot || containsMatch) loadFeature(feature);
    });
  };

  findFeatures(document);

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) findFeatures(node);
      });
    });

    if (features.every((feature) => feature.loading)) observer.disconnect();
  });

  if (features.some((feature) => !feature.loading)) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}
